"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutSchema = exports.CieloCredentialsSchema = exports.PagarMeCredentialsSchema = exports.CreateOrderSchema = exports.CreateCustomerSchema = exports.LoginSchema = void 0;
const Yup = __importStar(require("yup"));
const moment_1 = __importDefault(require("moment"));
const REQUIRED_FIELD = 'Este campo é obrigatório.';
const MUST_BE_VALID_EMAIL = 'Deve ser um email válido.';
const MUST_BE_VALID_CREDIT_CARD = 'Número inválido.';
const MUST_BE_VALID_CVV = 'CVV inválido.';
const MUST_BE_VALID_AND_FUTURE_EXPIRATION = 'Expiração deve ser válida e no futuro.';
const MUST_BE_VALID_EXPIRATION = 'Expiração deve ser válida.';
const MUST_BE_VALID_CEP = 'CEP inválido.';
const MUST_BE_VALID_PHONE_NUMBER = 'Telefone inválido.';
const MUST_BE_VALID_CELLPHONE_NUMBER = 'Celular inválido.';
const MUST_BE_VALID_CPF_OR_CNPJ = 'CPF/CNPJ inválido.';
const SELECT_ONE_OPTION = 'Selecione uma das opcões.';
exports.LoginSchema = Yup.object({
    email: Yup.string().email(MUST_BE_VALID_EMAIL).required(REQUIRED_FIELD),
    password: Yup.string()
        .min(8, 'Deve conter no mínimo 8 caracteres')
        .matches(/[a-z]+/, 'Deve conter no mínimo uma letra minúscula')
        .matches(/[A-Z]+/, 'Deve conter no mínimo uma letra maiúscula')
        .matches(/\d+/, 'Deve conter um número')
        .required(REQUIRED_FIELD)
});
exports.CreateCustomerSchema = Yup.object({
    email: Yup.string().email(MUST_BE_VALID_EMAIL).required(REQUIRED_FIELD),
    name: Yup.string().required(REQUIRED_FIELD)
});
exports.CreateOrderSchema = Yup.object({
    company_customer_id: Yup.string().required(REQUIRED_FIELD),
    company_gateway_id: Yup.string().required(REQUIRED_FIELD),
    price: Yup.number().min(1, 'Deve ser maior que R$ 1,00').required(REQUIRED_FIELD),
    installments: Yup.number().min(1, 'Deve ser maior que 1').required(REQUIRED_FIELD),
    locator: Yup.string().trim().max(100).optional().nullable(),
});
exports.PagarMeCredentialsSchema = Yup.object({
    api_key: Yup.string().required(REQUIRED_FIELD),
});
exports.CieloCredentialsSchema = Yup.object({
    merchant_ec: Yup.string().required(REQUIRED_FIELD),
    merchant_id: Yup.string().required(REQUIRED_FIELD),
    merchant_key: Yup.string().required(REQUIRED_FIELD),
    merchant_name: Yup.string().required(REQUIRED_FIELD),
    merchant_mcc: Yup.string().required(REQUIRED_FIELD),
    client_id: Yup.string().required(REQUIRED_FIELD),
    client_secret: Yup.string().required(REQUIRED_FIELD)
});
exports.CheckoutSchema = Yup.object({
    card_number: Yup.string().required(REQUIRED_FIELD)
        .test('valid-card-format', MUST_BE_VALID_CREDIT_CARD, value => {
        if (!value)
            return false;
        const numero = value.replace(/\D/g, '');
        // Verifica se é Amex
        if (/^3[47]\d{13}$/.test(numero)) {
            return true;
        }
        // Verifica se é Visa, MasterCard, etc. (apenas 16 dígitos)
        if (/^\d{16}$/.test(numero)) {
            return true;
        }
        console.log(numero);
        return false;
    }),
    cvv: Yup.string().length(3, MUST_BE_VALID_CVV).required(REQUIRED_FIELD),
    installments: Yup.number().min(1).required(REQUIRED_FIELD),
    expiry: Yup.string().test({
        test: (value, context) => {
            if (!value || (value === null || value === void 0 ? void 0 : value.length) < 5) {
                return context.createError({
                    message: REQUIRED_FIELD,
                    path: context.path
                });
            }
            const [month, year] = value.split('/');
            if (Number(month) > 12 || Number(month) === 0) {
                return context.createError({
                    message: MUST_BE_VALID_EXPIRATION,
                    path: context.path
                });
            }
            if (Number(year) < Number((0, moment_1.default)().format('YY')) || (Number(year) === Number((0, moment_1.default)().format('YY') && Number(month) <= Number((0, moment_1.default)().format('MM'))))) {
                return context.createError({
                    message: MUST_BE_VALID_AND_FUTURE_EXPIRATION,
                    path: context.path
                });
            }
            return true;
        },
    }),
    name: Yup.string().required(REQUIRED_FIELD)
});
